{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPIGroup} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/datepicker';
import statelyDocs from 'docs:@react-stately/datepicker';
import Anatomy from '/packages/dev/s2-docs/pages/react-aria/TimeFieldAnatomy.svg';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a time field component.';
export const isSubpage = true;

# useTimeField

<PageDescription>{docs.exports.useTimeField.description}</PageDescription>

```tsx render files={["starters/hooks/src/TimeField.tsx", "starters/hooks/src/DateField.css", "starters/hooks/src/TimeField.css", "starters/hooks/src/Form.css"]}
"use client";
import {TimeField} from 'hooks-starter/TimeField';

<TimeField label="Event time" />
```

## API

<Anatomy />

```tsx
<TimeField>
  <Label />
  <DateInput>
    {segment => <DateSegment segment={segment} />}
  </DateInput>
  <Text slot="description" />
  <FieldError />
</TimeField>
```

<FunctionAPIGroup
  functions={[
    {function: statelyDocs.exports.useTimeFieldState, links: statelyDocs.links},
    {function: docs.exports.useTimeField, links: docs.links},
  ]}
/>

### TimeFieldState

<InterfaceType {...statelyDocs.exports.TimeFieldState} links={statelyDocs.links} />

### AriaTimeFieldProps

<InterfaceType {...docs.exports.AriaTimeFieldProps} />
